import React, {useContext, useEffect} from 'react';
import {Media} from "reactstrap";
import localized from "../../i18n";
import authContext from "../../AuthProvider/authContext";
import axios from "axios";
import {handleError, showsuccesToast} from "../HandleError";
import {useNavigate} from "react-router-dom";

const TncAccept = () => {
    const navigate = useNavigate();
    const {logout, state, getAuthenticatedUser} = useContext(authContext);
    useEffect(() => {
        getAuthenticatedUser().then(() => {
            localStorage.setItem('lang', state.auth.language);
            localized.setLanguage(localStorage.getItem('lang'));
        })
    }, []);

    const acceptTerms = (values) => {
        axios.post("/api/edit-profile", values)
            .then((response) => {
                getAuthenticatedUser();
                navigate('/dashboard')
            }).catch((err) => {
            handleError(err);
        })
    }
    return (
        <div>
            <div className="p-4 justify-content-center dashboard-header-container custom_img">
                <Media
                    className={"img-fluid for-light "}
                    src={`${require("../../assets/images/logo/logo.png")}`}
                    alt={"logo image"}
                />
            </div>
            <div className="tnc_accept">
                <div className="tnc_heading" dangerouslySetInnerHTML={{__html: localized.general_conditions}}/>
                <div className="main_content">
                    <div className="inner_content">
                        <p className="custom_text1">{localized.effective}</p>
                        <p className="custom_text1">{localized.article_1_title}</p>
                        <p className="custom_text2">{localized.article_1_description}</p>
                        <p className="custom_text2">{localized.article_1_email_address}</p>
                        <p className="custom_text2">{localized.article_1_product_characteristics}</p>
                        <p className="custom_text2">{localized.article_1_choice_responsibility}</p>
                        <p className="custom_text2">{localized.article_1_stock_availability}</p>
                        <p className="custom_text2">{localized.article_1_accessibility}</p>
                        <p className="custom_text2">{localized.article_1_customer_declaration}</p>
                        <p className="custom_text2">{localized.article_1_proof_of_transaction}</p>
                        <p className="custom_text2">{localized.article_1_seller_details}</p>
                        <p className="custom_text2">{localized.seller_company}</p>
                        <p className="custom_text2">{localized.seller_share_capital}</p>
                        <p className="custom_text2">{localized.seller_registration}</p>
                        <p className="custom_text2">{localized.seller_address}</p>
                        <p className="custom_text2">{localized.seller_email}</p>
                        <p className="custom_text2">{localized.seller_phone}</p>
                        <p className="custom_text2">{localized.seller_vat_number}</p>
                        <p className="custom_text1">{localized.article_2_title}</p>
                        <p className="custom_text2">{localized.article_2_price_description}</p>
                        <p className="custom_text2">{localized.article_2_price_currency}</p>
                        <p className="custom_text2">{localized.article_2_price_reduction}</p>
                        <p className="custom_text2">{localized.article_2_price_validity}</p>
                        <p className="custom_text2">{localized.article_2_shipping_costs}</p>
                        <p className="custom_text2">{localized.article_2_total_amount}</p>
                        <p className="custom_text2">{localized.article_2_invoice}</p>
                        <p className="custom_text1">{localized.article_3_title}</p>
                        <p className="custom_text2">{localized.article_3_order_description}</p>
                        <p className="custom_text2">{localized.article_3_customer}</p>
                        <p className="custom_text2">{localized.article_3_offer_validity}</p>
                        <p className="custom_text2">{localized.article_3_order_validity}</p>
                        <p className="custom_text2">{localized.article_3_contract_formation}</p>
                        <p className="custom_text2">{localized.article_3_order_cancellation}</p>
                        <p className="custom_text2">{localized.article_3_order_tracking}</p>
                        <p className="custom_text1">{localized.article_3bis_title}</p>
                        <p className="custom_text2">{localized.article_3bis_account_creation}</p>
                        <p className="custom_text2">{localized.article_3bis_his_email}</p>
                        <p className="custom_text2">{localized.article_3bis_account_update}</p>
                        <p className="custom_text2">{localized.article_3bis_account_access}</p>
                        <p className="custom_text2">{localized.article_3bis_account_deletion}</p>
                        <p className="custom_text2">{localized.article_3bis_account_suspension}</p>
                        <p className="custom_text2">{localized.article_3bis_account_data_deletion}</p>
                        <p className="custom_text2">{localized.article_3bis_force_majeure}</p>
                        <p className="custom_text2">{localized.article_3bis_acceptance_conditions}</p>
                        <p className="custom_text1" dangerouslySetInnerHTML={{__html: localized.article_4_title}}/>
                        <p className="custom_text2"
                           dangerouslySetInnerHTML={{__html: localized.article_4_payment_terms}}/>
                        <p className="custom_text1" dangerouslySetInnerHTML={{__html: localized.article_5_title}}/>
                        <p className="custom_text2"
                           dangerouslySetInnerHTML={{__html: localized.article_5_delivery_area}}/>
                        <p className="custom_text1" dangerouslySetInnerHTML={{__html: localized.article_6_title}}/>
                        <p className="custom_text2"
                           dangerouslySetInnerHTML={{__html: localized.article_6_delivery_area}}/>
                        <p className="custom_text1" dangerouslySetInnerHTML={{__html: localized.article_7_title}}/>
                        <p className="custom_text2"
                           dangerouslySetInnerHTML={{__html: localized.article_7_delivery_area}}/>
                        <p className="custom_text1" dangerouslySetInnerHTML={{__html: localized.article_8_title}}/>
                        <p className="custom_text2"
                           dangerouslySetInnerHTML={{__html: localized.article_8_delivery_area}}/>
                        <p className="custom_text1" dangerouslySetInnerHTML={{__html: localized.article_9_title}}/>
                        <p className="custom_text2"
                           dangerouslySetInnerHTML={{__html: localized.article_9_delivery_area}}/>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mt-4 ">
                        <div className="custom_btn">
                            <button
                                className="btn btn-primary"
                                onClick={() => logout(true)}
                            >{localized.logout}
                            </button>
                        </div>
                        <div>
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    const data = {...state.auth};
                                    data.terms_accepted = 1;
                                    acceptTerms(data)
                                }}
                            >
                                Accept
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default TncAccept;